export const selectionStates = {
    selected: "success",
    unselected: "default",
    mixed: "secondary",
};
